import React from 'react'
import { usePutRequest } from '../hooks/request'
import ServerError from './componentsFinance/common/ServerError'
import ManthlyDueDateForm from './ManthlyDueDateForm'
import { MANTHLY_DUE_DATE_DETAIL } from '../urls'

export default function ManthlyDueDateUpdate({ onCancel, onUpdate, report }) {
    const url = MANTHLY_DUE_DATE_DETAIL.replace('{id}', report.id)
    const rotationUpdate = usePutRequest({ url })

    async function onSubmit(data, actions) {
        const { success } = await rotationUpdate.request({ data })

        if (success) {
            actions.resetForm()
            onUpdate()
        }
    }

    return (
        <div>
            <b>Изменить данные о враче</b><br /><br />
            <ServerError error={rotationUpdate.error} />
            <ManthlyDueDateForm
                initialValues={report}
                onSubmit={onSubmit}
                onCancel={onCancel}
                loading={rotationUpdate.loading} />
        </div>
    )
}
